export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REQUEST_PROVIDE = 'AUTH_REQUEST_PROVIDE';
export const AUTH_REQUEST_VIA_APP = 'AUTH_REQUEST_VIA_APP';

export const AUTH_REQUEST_CONFIRM_TOKEN = 'AUTH_REQUEST_CONFIRM_TOKEN';
export const AUTH_REQUEST_CONFIRM_TOKEN_SUCCESS = 'AUTH_REQUEST_CONFIRM_TOKEN_SUCCESS';
